const VALIDATION_MESSAGES = {
  'present1_onlyOne': 'Please select just one option: "yes" or "no".',
  'present2_onlyOne': 'Please select just one option: "yes" or "no".',
  'present3_onlyOne': 'Please select just one option: "yes" or "no".',
  'present4_onlyOne': 'Please select just one option: "yes" or "no".',
  'present5_onlyOne': 'Please select just one option: "yes" or "no".',
  'present6_onlyOne': 'Please select just one option: "yes" or "no".',
  'present7_onlyOne': 'Please select just one option: "yes" or "no".',
  'present8_onlyOne': 'Please select just one option: "yes" or "no".',
  'present9_onlyOne': 'Please select just one option: "yes" or "no".',
  'present10_onlyOne': 'Please select just one option: "yes" or "no".',
  'present11_onlyOne': 'Please select just one option: "yes" or "no".',
  'fuelType1_onlyOne': 'Please select only one fuel type.',
  'fuelType2_onlyOne': 'Please select only one fuel type.',
  'fuelType3_onlyOne': 'Please select only one fuel type.',
  'fuelType4_onlyOne': 'Please select only one fuel type.',
  'fuelType5_onlyOne': 'Please select only one fuel type.',
  'fuelType6_onlyOne': 'Please select only one fuel type.',
  'fuelType7_onlyOne': 'Please select only one fuel type.',
  'fuelType8_onlyOne': 'Please select only one fuel type.',
  'fuelType9_onlyOne': 'Please select only one fuel type.',
  'fuelType10_onlyOne': 'Please select only one fuel type.',
  'fuelType11_onlyOne': 'Please select only one fuel type.',
  'status1_onlyOne': 'Please select only one status result.',
  'status2_onlyOne': 'Please select only one status result.',
  'status3_onlyOne': 'Please select only one status result.',
  'status4_onlyOne': 'Please select only one status result.',
  'status5_onlyOne': 'Please select only one status result.',
  'status6_onlyOne': 'Please select only one status result.',
  'status7_onlyOne': 'Please select only one status result.',
  'status8_onlyOne': 'Please select only one status result.',
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "cookingAppliancePresent_yes": () => ({
      validate: () => {
        const yesNo = ["cookingAppliancePresent_yes", "cookingAppliancePresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present1_onlyOne'];
      },
    }),
    "dryerPresent_yes": () => ({
      validate: () => {
        const yesNo = ["dryerPresent_yes", "dryerPresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present2_onlyOne'];
      },
    }),
    "fireplacePresent_yes": () => ({
      validate: () => {
        const yesNo = ["fireplacePresent_yes", "fireplacePresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present3_onlyOne'];
      },
    }),
    "primaryHeatSourcePresent_yes": () => ({
      validate: () => {
        const yesNo = ["primaryHeatSourcePresent_yes", "primaryHeatSourcePresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present4_onlyOne'];
      },
    }),
    "secondaryHeatSource_yes": () => ({
      validate: () => {
        const yesNo = ["secondaryHeatSource_yes", "secondaryHeatSource  _no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present5_onlyOne'];
      },
    }),
    "gasPresent_yes": () => ({
      validate: () => {
        const yesNo = ["gasPresent_yes", "gasPresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present6_onlyOne'];
      },
    }),
    "heaterPresent_yes": () => ({
      validate: () => {
        const yesNo = ["heaterPresent_yes", "heaterPresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present7_onlyOne'];
      },
    }),
    "freestandingHeaterPresent_yes": () => ({
      validate: () => {
        const yesNo = ["freestandingHeaterPresent_yes", "freestandingHeaterPresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present8_onlyOne'];
      },
    }),
    "waterHeaterPresent_yes": () => ({
      validate: () => {
        const yesNo = ["waterHeaterPresent_yes", "waterHeaterPresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present9_onlyOne'];
      },
    }),
    "woodstovePresent_yes": () => ({
      validate: () => {
        const yesNo = ["woodstovePresent_yes", "woodstovePresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present10_onlyOne'];
      },
    }),
    "otherPresent_yes": () => ({
      validate: () => {
        const yesNo = ["otherPresent_yes", "otherPresent_no"];
        const count = yesNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['present11_onlyOne'];
      },
    }),
    "cookingAppliance_coal": () => ({
      validate: () => {
        if (getValues('cookingAppliancePresent_yes')) {
          const options = ["cookingAppliance_coal", "cookingAppliance_elec", "cookingAppliance_kero", "cookingAppliance_lp", "cookingAppliance_natGas", "cookingAppliance_oil", "cookingAppliance_pellet", "cookingAppliance_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType1_onlyOne'];
        }
        else return
      },
    }),
    "dryer_coal": () => ({
      validate: () => {
        if (getValues('dryer_yes')) {
          const options = ["dryer_coal", "dryer_elec", "dryer_kero", "dryer_lp", "dryer_natGas", "dryer_oil", "dryer_pellet", "dryer_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType2_onlyOne'];
        }
        else return
      },
    }),
    "fireplace_coal": () => ({
      validate: () => {
        if (getValues('fireplace_yes')) {
          const options = ["fireplace_coal", "fireplace_elec", "fireplace_kero", "fireplace_lp", "fireplace_natGas", "fireplace_oil", "fireplace_pellet", "fireplace_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType3_onlyOne'];
        }
        else return
      },
    }),
    "primaryHeatSource_coal": () => ({
      validate: () => {
        if (getValues('primaryHeatSource_yes')) {
          const options = ["primaryHeatSource_coal", "primaryHeatSource_elec", "primaryHeatSource_kero", "primaryHeatSource_lp", "primaryHeatSource_natGas", "primaryHeatSource_oil", "primaryHeatSource_pellet", "primaryHeatSource_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType4_onlyOne'];
        }
        else return
      },
    }),
    "secondaryHeatSource_coal": () => ({
      validate: () => {
        if (getValues('secondaryHeatSource_yes')) {
          const options = ["secondaryHeatSource_coal", "secondaryHeatSource_elec", "secondaryHeatSource_kero", "secondaryHeatSource_lp", "secondaryHeatSource_natGas", "secondaryHeatSource_oil", "secondaryHeatSource_pellet", "secondaryHeatSource_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType5_onlyOne'];
        }
        else return
      },
    }),
    "gas_coal": () => ({
      validate: () => {
        if (getValues('gas_yes')) {
          const options = ["gas_coal", "gas_elec", "gas_kero", "gas_lp", "gas_natGas", "gas_oil", "gas_pellet", "gas_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType6_onlyOne'];
        }
        else return
      },
    }),
    "heater_coal": () => ({
      validate: () => {
        if (getValues('heater_yes')) {
          const options = ["heater_coal", "heater_elec", "heater_kero", "heater_lp", "heater_natGas", "heater_oil", "heater_pellet", "heater_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType7_onlyOne'];
        }
        else return
      },
    }),
    "freestandingHeater_coal": () => ({
      validate: () => {
        if (getValues('freestandingHeater_yes')) {
          const options = ["freestandingHeater_coal", "freestandingHeater_elec", "freestandingHeater_kero", "freestandingHeater_lp", "freestandingHeater_natGas", "freestandingHeater_oil", "freestandingHeater_pellet", "freestandingHeater_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType8_onlyOne'];
        }
        else return
      },
    }),
    "waterHeater_coal": () => ({
      validate: () => {
        if (getValues('waterHeater_yes')) {
          const options = ["waterHeater_coal", "waterHeater_elec", "waterHeater_kero", "waterHeater_lp", "waterHeater_natGas", "waterHeater_oil", "waterHeater_pellet", "waterHeater_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType9_onlyOne'];
        }
        else return
      },
    }),
    "woodstove_coal": () => ({
      validate: () => {
        if (getValues('woodstove_yes')) {
          const options = ["woodstove_coal", "woodstove_elec", "woodstove_kero", "woodstove_lp", "woodstove_natGas", "woodstove_oil", "woodstove_pellet", "woodstove_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType10_onlyOne'];
        }
        else return
      },
    }),
    "other_coal": () => ({
      validate: () => {
        if (getValues('other_yes')) {
          const options = ["other_coal", "other_elec", "other_kero", "other_lp", "other_natGas", "other_oil", "other_pellet", "other_wood"];
          const count = options.filter(option => !!getValues(option)).length;
          return (count === 1) || VALIDATION_MESSAGES['fuelType11_onlyOne'];
        }
        else return
      },
    }),
    "primaryHeat_statusPass": () => ({
      validate: () => {
        const options = ["primaryHeat_statusPass", "primaryHeat_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status1_onlyOne'];
      },
    }),
    "secondaryHeat_statusPass": () => ({
      validate: () => {
        const options = ["secondaryHeat_statusPass", "secondaryHeat_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status2_onlyOne'];
      },
    }),
    "waterHeater_statusPass": () => ({
      validate: () => {
        const options = ["waterHeater_statusPass", "waterHeater_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status3_onlyOne'];
      },
    }),
    "gas_statusPass": () => ({
      validate: () => {
        const options = ["gas_statusPass", "gas_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status4_onlyOne'];
      },
    }),
    "portableHeater_statusPass": () => ({
      validate: () => {
        const options = ["portableHeater_statusPass", "portableHeater_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status5_onlyOne'];
      },
    }),
    "cookingAppliance_statusPass": () => ({
      validate: () => {
        const options = ["cookingAppliance_statusPass", "cookingAppliance_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status6_onlyOne'];
      },
    }),
    "dryer_statusPass": () => ({
      validate: () => {
        const options = ["dryer_statusPass", "dryer_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status7_onlyOne'];
      },
    }),
    "other_statusPass": () => ({
      validate: () => {
        const options = ["other_statusPass", "other_statusHazard"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['status8_onlyOne'];
      },
    }),
  };
};

export default useValidation;
